/* global $ */
import ApiService from '@/services/common/api.service';
import StorageService from '@/services/common/storage.service';
import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import { Role } from '@/helpers/role';

import _ from 'lodash';

const UserManagementService = {
    listUser,
    addUser,
    deleteUser,
    resetPassUser,
    editUser,
    detailUser,
    getRoleNameByRoleId,
    getUser,
    resetSecretKeyUser,
};

/*
    List User
*/
async function listUser (search, page) {
    let url = '/users/search';

    let query = {};

    if (page) {
        query.page = page;
        query.pageSize = Constants.ItemPerpage;
    }

    if (search.name) {
        query.name = _.trim(search.name);
    }

    if (search.groupId) {
        query.groupId = search.groupId;
    }

    if (search.companyId) {
        query.companyId = search.companyId;
    }

    if (search.tourNumber) {
        query.tourNumber = search.tourNumber;
    }

    if (search.organizationName) {
        query.organizationName = search.organizationName
    }


    if (Utils.isEmptyObj(query) == false) {
        let httpBuildQuery = require('http-build-query');
        url += "?" + httpBuildQuery(query);
    }

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Add User
*/
async function addUser (params) {
    let url = '/users';

    let body = {};

    Utils.trimObject(params);

    body.username = _.trim(params.username);
    body.fullName = _.trim(params.fullName);
    body.groupId = params.groupId;
    body.roleId = params.roleId;

    if (!Utils.isEmptyStr(params.validPeriodFrom)) {
        body.validPeriodFrom = DateUtils.formatDateDefault(params.validPeriodFrom);
    } else {
        body.validPeriodFrom = "";
    }

    if (!Utils.isEmptyStr(params.validPeriodTo)) {
        body.validPeriodTo = DateUtils.formatDateDefault(params.validPeriodTo);
    } else {
        body.validPeriodTo = "";
    }

    try {
        let response = await ApiService.post(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Detail User
*/
async function detailUser (id) {
    let url = '/users/' + id;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Edit User
*/
async function editUser (id, params, allowEditStartDate, allowEditEndDate) {
    let url = '/users';
    let body = {};

    Utils.trimObject(params);

    if (id.length == 1) {
        url = url + "/" + id[0];
        body.username = _.trim(params.username);
        body.fullName = _.trim(params.fullName);
    } else {
        body.ids = id;
    }

    if (!Utils.isEmptyStr(params.groupId)) {
        body.groupId = params.groupId;
    }

    if (!Utils.isEmptyStr(params.roleId)) {
        body.roleId = params.roleId;
    }

    if (!Utils.isEmptyStr(params.validPeriodFrom)) {
        body.validPeriodFrom = DateUtils.formatDateDefault(params.validPeriodFrom);
    } else {
        body.validPeriodFrom = "";
    }

    if (!Utils.isEmptyStr(params.validPeriodTo)) {
        body.validPeriodTo = DateUtils.formatDateDefault(params.validPeriodTo);
    } else {
        body.validPeriodTo = "";
    }

    if (!Utils.isEmptyStr(params.password)) {
        body.password = params.password;
    } else {
        body.password = null;
    }

    // Check allow edit date start
    if (id.length > 1 && !allowEditStartDate) {
        _.unset(body, 'validPeriodFrom');
    }
    // Check allow edit date end
    if (id.length > 1 && !allowEditEndDate) {
        _.unset(body, 'validPeriodTo');
    }

    try {
        let response = await ApiService.put(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Delete User
*/
async function deleteUser (ids) {
    let url = '/users';
    let body = {};

    if (ids.length == 1) {
        url = url + "/" + ids[0];
    } else {
        body.ids = ids;
    }

    let requestData = {
        method: 'DELETE',
        url: url,
        data: body,
    };

    try {
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Reset Pass User
*/
async function resetPassUser (ids) {
    let url = '/users/password_reset';
    let body = {};

    body.ids = ids;

    let requestData = {
        method: 'PUT',
        url: url,
        data: body,
    };

    try {
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

function getRoleNameByRoleId (id) {
    let roleName = "";
    $.each(Role, function (key, value) {
        if (value.id == id) {
            roleName = value.name;
            return false;
        }
    });
    return roleName;
}

async function getUser (placeId = "") {
    let url = '/users/get?placeId=' + placeId;

    try {
        let response = await ApiService.get(url);
        if (response) {
            StorageService.saveUser(JSON.stringify(response.data));
        }
    } catch (error) {
        return error;
    }
}
/*
    Reset SecretKey User
*/
async function resetSecretKeyUser (ids) {

    const body = {}

    const result = ids.map(async (id) => {


        try {
            let url = `/users/${id}/secret_keys`;
            let requestData = {
                method: 'PUT',
                url: url,
                data: body,
            };
    
            const response = await ApiService.customRequest(requestData);
            return response;
        } catch (error) {
            return error;
        }
    });

    return Promise.all(result);
}

export default UserManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/user.service.js